import { DownloadIcon } from '@/components/icons';

interface DownloadButtonProps {
  href: string;
  label: string;
}

/**
 * Patient care download button — outlined / large with a gray border, the
 * download icon on the left, and 14px SemiBold midnight text. Hover state
 * matches the rest of the outlined button family (`bg-clearlab-divider-light/20`).
 *
 * Figma (large, 1440px):
 *   - 0.7px border `#D8D5D2` (clearlab-divider-darker)
 *   - rounded 12px (rounded-lg) — site-wide standard
 *   - 12px horizontal × 16px vertical padding
 *   - 8px gap between icon (16×16) and label
 *   - Karla SemiBold 14/16 midnight text
 *
 * Renders an `<a download>` so the browser saves the PDF directly. The link
 * also opens in a new tab as a fallback for browsers that ignore `download`
 * for a given response.
 */
export function DownloadButton({ href, label }: DownloadButtonProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      download
      className="group inline-flex w-full items-center justify-center gap-2 rounded-lg border-[0.7px] border-clearlab-divider-darker px-3 py-4 text-[14px] font-semibold text-clearlab-midnight transition-colors duration-fast ease-smooth hover:bg-clearlab-divider-light/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
    >
      <DownloadIcon className="size-4" />
      <span>{label}</span>
    </a>
  );
}
